import { useState, useEffect, useMemo } from "react";
import { Dialog, Box } from "@mui/material";
import QuestionForm from "components/Questions/QuestionForm";

/**
 *
 * @param {object} props
 * @param {object} props.question
 * @param {boolean} props.show
 * @param {(updatedQuestion: object) => void} props.onQuestionUpdated
 * @param {() => void} props.onClose
 */
function UpdateQuestionDialog({ show, question, onQuestionUpdated, onClose }) {
    const [open, setOpen] = useState(false);

    const questionToEdit = useMemo(
        () =>
            question && {
                ...question,
                questionType: question.type,
            },
        [question],
    );

    const handleClose = () => {
        setOpen(false);
        onClose(false);
    };

    useEffect(() => {
        setOpen(show);
    }, [show]);

    return (
        <Dialog
            maxWidth="md"
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="bg-transparent overflow-hidden border-none"
            PaperProps={{
                style: { borderRadius: 15, maxWidth: 700 },
            }}
        >
            <Box className="mx-[45px] py-[49px]">
                <div className="text-[#455468] text-[22px] mb-[30px]">Update Question</div>
                <QuestionForm
                    questionToEdit={questionToEdit}
                    onQuestionUpdated={(question) => {
                        onQuestionUpdated(question);
                        handleClose();
                    }}
                    onCancel={handleClose}
                    disableClearFormOnCancel
                />
            </Box>
        </Dialog>
    );
}

export default UpdateQuestionDialog;
